import React from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment-timezone';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { UserProvider } from './auth/User.context';

// Prevent CE.SDK from selecting its Node runtime path in browser builds
if (typeof Reflect.get(window, '__filename') === 'undefined') {
  Reflect.set(window, '__filename', window.location.href);
}

moment.tz.setDefault('UTC');

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <UserProvider>
    <App />
  </UserProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
